module.exports = __webpack_public_path__ + "static/media/Appmixer_screen.df601053.png";